import { useEffect } from 'react';
import { useFormikContext } from 'formik';

/**
 * A component that automatically scrolls to and focuses the first form field
 * with a validation error when a Formik form is submitted.
 *
 * Usage: Place <FocusError /> anywhere inside a Formik form.
 */
const FocusError: React.FC = () => {
  const { errors, isSubmitting, isValidating } = useFormikContext();

  useEffect(() => {
    if (isSubmitting && !isValidating) {
      const keys = Object.keys(errors);
      if (keys.length > 0) {
        const selector = `[name=${keys[0]}]`;
        const errorElement = document.querySelector(selector) as HTMLElement;
        if (errorElement) {
          errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          errorElement.focus({ preventScroll: true });
        }
      }
    }
  }, [errors, isSubmitting, isValidating]);

  return null;
};

export default FocusError;
